type Coordinates = {
  lat: number;
  lng: number;
}

export const COUNTRY_COORDINATES: { [countryCode: string]: { sw: Coordinates; ne: Coordinates } } = {
  'AF': {
    sw: {
      lat: 29.377200,
      lng: 60.517000,
    },
    ne: {
      lat: 38.490877,
      lng: 74.889862,
    },
  },
  'AL': {
    sw: {
      lat: 39.644730,
      lng: 19.263904,
    },
    ne: {
      lat: 42.661082,
      lng: 21.057239,
    },
  },
  'DZ': {
    sw: {
      lat: 18.968147,
      lng: -8.666667,
    },
    ne: {
      lat: 37.089821,
      lng: 12.000000,
    },
  },
  'AD': {
    sw: {
      lat: 42.428749,
      lng: 1.408705,
    },
    ne: {
      lat: 42.655791,
      lng: 1.786639,
    },
  },
  'AO': {
    sw: {
      lat: -18.039104,
      lng: 11.669562,
    },
    ne: {
      lat: -4.387944,
      lng: 24.084444,
    },
  },
  'Antigua': {
    sw: {
      lat: 16.997626,
      lng: -61.906251,
    },
    ne: {
      lat: 17.173760,
      lng: -61.673155,
    },
  },
  'AR': {
    sw: {
      lat: -55.057715,
      lng: -73.560360,
    },
    ne: {
      lat: -21.780814,
      lng: -53.637481,
    },
  },
  'AM': {
    sw: {
      lat: 38.840244,
      lng: 43.447212,
    },
    ne: {
      lat: 41.300993,
      lng: 46.634222,
    },
  },
  'AU': {
    sw: {
      lat: -54.777219,
      lng: 112.921454,
    },
    ne: {
      lat: -9.221084,
      lng: 159.255528,
    },
  },
  'AT': {
    sw: {
      lat: 46.372336,
      lng: 9.530783,
    },
    ne: {
      lat: 49.020608,
      lng: 17.160686,
    },
  },
  'AZ': {
    sw: {
      lat: 38.391990,
      lng: 44.764683,
    },
    ne: {
      lat: 41.912340,
      lng: 50.467866,
    },
  },
  'BS': {
    sw: {
      lat: 20.912131,
      lng: -80.474947,
    },
    ne: {
      lat: 27.263362,
      lng: -72.712069,
    },
  },
  'BH': {
    sw: {
      lat: 25.556458,
      lng: 50.378151,
    },
    ne: {
      lat: 26.330394,
      lng: 50.824846,
    },
  },
  'BD': {
    sw: {
      lat: 20.754380,
      lng: 88.008589,
    },
    ne: {
      lat: 26.634243,
      lng: 92.680115,
    },
  },
  'BB': {
    sw: {
      lat: 13.045000,
      lng: -59.651030,
    },
    ne: {
      lat: 13.335126,
      lng: -59.420098,
    },
  },
  'BY': {
    sw: {
      lat: 51.262011,
      lng: 23.178338,
    },
    ne: {
      lat: 56.171872,
      lng: 32.776820,
    },
  },
  'BE': {
    sw: {
      lat: 49.497013,
      lng: 2.544795,
    },
    ne: {
      lat: 51.505145,
      lng: 6.408124,
    },
  },
  'BZ': {
    sw: {
      lat: 15.885619,
      lng: -89.227588,
    },
    ne: {
      lat: 18.495942,
      lng: -87.491727,
    },
  },
  'BJ': {
    sw: {
      lat: 6.234832,
      lng: 0.776667,
    },
    ne: {
      lat: 12.408611,
      lng: 3.843343,
    },
  },
  'BT': {
    sw: {
      lat: 26.702016,
      lng: 88.746473,
    },
    ne: {
      lat: 28.360825,
      lng: 92.125232,
    },
  },
  'BO': {
    sw: {
      lat: -22.898090,
      lng: -69.644990,
    },
    ne: {
      lat: -9.669323,
      lng: -57.453803,
    },
  },
  'BW': {
    sw: {
      lat: -26.907545,
      lng: 19.998905,
    },
    ne: {
      lat: -17.778137,
      lng: 29.375304,
    },
  },
  'BR': {
    sw: {
      lat: -33.751748,
      lng: -73.982817,
    },
    ne: {
      lat: 5.271602,
      lng: -29.345024,
    },
  },
  'BN': {
    sw: {
      lat: 4.002508,
      lng: 114.076063,
    },
    ne: {
      lat: 5.082646,
      lng: 115.363562,
    },
  },
  'BG': {
    sw: {
      lat: 41.235447,
      lng: 22.357345,
    },
    ne: {
      lat: 44.215233,
      lng: 28.609263,
    },
  },
  'BF': {
    sw: {
      lat: 9.393889,
      lng: -5.521111,
    },
    ne: {
      lat: 15.085111,
      lng: 2.404293,
    },
  },
  'BI': {
    sw: {
      lat: -4.469228,
      lng: 29.000993,
    },
    ne: {
      lat: -2.309987,
      lng: 30.850173,
    },
  },
  'KH': {
    sw: {
      lat: 9.276808,
      lng: 102.333542,
    },
    ne: {
      lat: 14.690179,
      lng: 107.627687,
    },
  },
  'CM': {
    sw: {
      lat: 1.655900,
      lng: 8.494763,
    },
    ne: {
      lat: 13.083335,
      lng: 16.194408,
    },
  },
  'CA': {
    sw: {
      lat: 41.676556,
      lng: -141.001870,
    },
    ne: {
      lat: 83.115061,
      lng: -52.619409,
    },
  },
  'CV': {
    sw: {
      lat: 14.802351,
      lng: -25.360994,
    },
    ne: {
      lat: 17.205287,
      lng: -22.657778,
    },
  },
  'TD': {
    sw: {
      lat: 7.442975,
      lng: 13.470000,
    },
    ne: {
      lat: 23.449235,
      lng: 24.000001,
    },
  },
  'CL': {
    sw: {
      lat: -55.979781,
      lng: -109.454881,
    },
    ne: {
      lat: -17.498329,
      lng: -66.418202,
    },
  },
  'CN': {
    sw: {
      lat: 18.153522,
      lng: 73.499414,
    },
    ne: {
      lat: 53.560974,
      lng: 134.772810,
    },
  },
  'CO': {
    sw: {
      lat: -4.227110,
      lng: -81.735930,
    },
    ne: {
      lat: 13.397350,
      lng: -66.851923,
    },
  },
  'KM': {
    sw: {
      lat: -12.413821,
      lng: 43.219421,
    },
    ne: {
      lat: -11.364639,
      lng: 44.540570,
    },
  },
  'CG': {
    sw: {
      lat: -5.028949,
      lng: 11.149548,
    },
    ne: {
      lat: 3.707791,
      lng: 18.643611,
    },
  },
  'CR': {
    sw: {
      lat: 5.499153,
      lng: -87.094513,
    },
    ne: {
      lat: 11.219681,
      lng: -82.552657,
    },
  },
  'HR': {
    sw: {
      lat: 42.392265,
      lng: 13.489691,
    },
    ne: {
      lat: 46.555223,
      lng: 19.448052,
    },
  },
  'CU': {
    sw: {
      lat: 19.825899,
      lng: -85.071247,
    },
    ne: {
      lat: 23.276752,
      lng: -74.132223,
    },
  },
  'CY': {
    sw: {
      lat: 34.632303,
      lng: 32.268708,
    },
    ne: {
      lat: 35.707200,
      lng: 34.604500,
    },
  },
  'CZ': {
    sw: {
      lat: 48.551808,
      lng: 12.090589,
    },
    ne: {
      lat: 51.055719,
      lng: 18.859236,
    },
  },
  'DK': {
    sw: {
      lat: 54.464597,
      lng: 8.072241,
    },
    ne: {
      lat: 57.751813,
      lng: 15.197281,
    },
  },
  'DJ': {
    sw: {
      lat: 10.931944,
      lng: 41.759722,
    },
    ne: {
      lat: 12.713396,
      lng: 43.416973,
    },
  },
  'DM': {
    sw: {
      lat: 15.207682,
      lng: -61.479830,
    },
    ne: {
      lat: 15.640064,
      lng: -61.240303,
    },
  },
  'TL': {
    sw: {
      lat: -9.504195,
      lng: 124.041738,
    },
    ne: {
      lat: -8.126807,
      lng: 127.341635,
    },
  },
  'EC': {
    sw: {
      lat: -5.014351,
      lng: -92.013048,
    },
    ne: {
      lat: 1.687211,
      lng: -75.188794,
    },
  },
  'EG': {
    sw: {
      lat: 22.000000,
      lng: 24.696775,
    },
    ne: {
      lat: 31.671535,
      lng: 36.894545,
    },
  },
  'SV': {
    sw: {
      lat: 13.155431,
      lng: -90.126810,
    },
    ne: {
      lat: 14.450557,
      lng: -87.683752,
    },
  },
  'ER': {
    sw: {
      lat: 12.354723,
      lng: 36.433348,
    },
    ne: {
      lat: 18.021210,
      lng: 43.142977,
    },
  },
  'EE': {
    sw: {
      lat: 57.509316,
      lng: 21.764313,
    },
    ne: {
      lat: 59.685685,
      lng: 28.210139,
    },
  },
  'ET': {
    sw: {
      lat: 3.404136,
      lng: 32.997734,
    },
    ne: {
      lat: 14.894215,
      lng: 48.000000,
    },
  },
  'FJ': {
    sw: {
      lat: -20.669430,
      lng: 176.909494,
    },
    ne: {
      lat: -12.479535,
      lng: -178.230107,
    },
  },
  'FI': {
    sw: {
      lat: 59.705440,
      lng: 20.547411,
    },
    ne: {
      lat: 70.092293,
      lng: 31.587100,
    },
  },
  'FR': {
    sw: {
      lat: 41.342328,
      lng: -5.141228,
    },
    ne: {
      lat: 51.089166,
      lng: 9.560068,
    },
  },
  'GA': {
    sw: {
      lat: -3.958372,
      lng: 8.699053,
    },
    ne: {
      lat: 2.318109,
      lng: 14.520556,
    },
  },
  'GM': {
    sw: {
      lat: 13.065183,
      lng: -16.813631,
    },
    ne: {
      lat: 13.826389,
      lng: -13.798611,
    },
  },
  'GE': {
    sw: {
      lat: 30.355591,
      lng: -85.605165,
    },
    ne: {
      lat: 35.000659,
      lng: -80.840787,
    },
  },
  'DE': {
    sw: {
      lat: 47.270112,
      lng: 5.866342,
    },
    ne: {
      lat: 55.058347,
      lng: 15.041896,
    },
  },
  'GH': {
    sw: {
      lat: 4.738874,
      lng: -3.260786,
    },
    ne: {
      lat: 11.166668,
      lng: 1.199363,
    },
  },
  'GR': {
    sw: {
      lat: 34.801021,
      lng: 19.372423,
    },
    ne: {
      lat: 41.748878,
      lng: 29.645148,
    },
  },
  'GD': {
    sw: {
      lat: 11.984873,
      lng: -61.802728,
    },
    ne: {
      lat: 12.530183,
      lng: -61.377997,
    },
  },
  'GT': {
    sw: {
      lat: 13.740021,
      lng: -92.231836,
    },
    ne: {
      lat: 17.815697,
      lng: -88.225615,
    },
  },
  'GN': {
    sw: {
      lat: 7.190909,
      lng: -15.078206,
    },
    ne: {
      lat: 12.674617,
      lng: -7.637853,
    },
  },
  'GW': {
    sw: {
      lat: 10.859970,
      lng: -16.711736,
    },
    ne: {
      lat: 12.684723,
      lng: -13.627504,
    },
  },
  'GY': {
    sw: {
      lat: 1.164724,
      lng: -61.414905,
    },
    ne: {
      lat: 8.546628,
      lng: -56.491120,
    },
  },
  'HT': {
    sw: {
      lat: 18.022078,
      lng: -74.480910,
    },
    ne: {
      lat: 20.089614,
      lng: -71.621754,
    },
  },
  'HN': {
    sw: {
      lat: 12.984225,
      lng: -89.355148,
    },
    ne: {
      lat: 17.417104,
      lng: -83.127534,
    },
  },
  'HU': {
    sw: {
      lat: 45.737089,
      lng: 16.113387,
    },
    ne: {
      lat: 48.585234,
      lng: 22.898122,
    },
  },
  'IS': {
    sw: {
      lat: 63.296102,
      lng: -24.546524,
    },
    ne: {
      lat: 66.566318,
      lng: -13.495815,
    },
  },
  'IN': {
    sw: {
      lat: 6.753516,
      lng: 68.162386,
    },
    ne: {
      lat: 35.504475,
      lng: 97.395555,
    },
  },
  'ID': {
    sw: {
      lat: -11.007436,
      lng: 95.009707,
    },
    ne: {
      lat: 6.076912,
      lng: 141.019562,
    },
  },
  'IR': {
    sw: {
      lat: 25.059429,
      lng: 44.031891,
    },
    ne: {
      lat: 39.781676,
      lng: 63.333337,
    },
  },
  'IQ': {
    sw: {
      lat: 29.061208,
      lng: 38.793603,
    },
    ne: {
      lat: 37.380932,
      lng: 48.575916,
    },
  },
  'IE': {
    sw: {
      lat: 51.421938,
      lng: -10.669580,
    },
    ne: {
      lat: 55.388490,
      lng: -5.994700,
    },
  },
  'IL': {
    sw: {
      lat: 29.479700,
      lng: 34.267387,
    },
    ne: {
      lat: 33.332805,
      lng: 35.896244,
    },
  },
  'IT': {
    sw: {
      lat: 35.492920,
      lng: 6.626720,
    },
    ne: {
      lat: 47.092000,
      lng: 18.520502,
    },
  },
  'JM': {
    sw: {
      lat: 17.705724,
      lng: -78.368846,
    },
    ne: {
      lat: 18.525310,
      lng: -76.183159,
    },
  },
  'JP': {
    sw: {
      lat: 24.046045,
      lng: 122.933830,
    },
    ne: {
      lat: 45.522772,
      lng: 153.987430,
    },
  },
  'JO': {
    sw: {
      lat: 29.185036,
      lng: 34.958337,
    },
    ne: {
      lat: 33.374688,
      lng: 39.301154,
    },
  },
  'KZ': {
    sw: {
      lat: 40.568584,
      lng: 46.493672,
    },
    ne: {
      lat: 55.441984,
      lng: 87.315415,
    },
  },
  'KE': {
    sw: {
      lat: -4.679682,
      lng: 33.909821,
    },
    ne: {
      lat: 5.033421,
      lng: 41.906832,
    },
  },
  'KI': {
    sw: {
      lat: -11.446519,
      lng: 169.521532,
    },
    ne: {
      lat: 4.699959,
      lng: -150.196032,
    },
  },
  'KP': {
    sw: {
      lat: 37.673332,
      lng: 124.173553,
    },
    ne: {
      lat: 43.011590,
      lng: 130.688500,
    },
  },
  'KR': {
    sw: {
      lat: 33.106110,
      lng: 124.608139,
    },
    ne: {
      lat: 38.616931,
      lng: 130.923218,
    },
  },
  'XK': {
    sw: {
      lat: 41.857641,
      lng: 20.014284,
    },
    ne: {
      lat: 43.268899,
      lng: 21.789867,
    },
  },
  'KW': {
    sw: {
      lat: 28.524446,
      lng: 46.553040,
    },
    ne: {
      lat: 30.103699,
      lng: 48.430458,
    },
  },
  'KG': {
    sw: {
      lat: 39.180254,
      lng: 69.250998,
    },
    ne: {
      lat: 43.265357,
      lng: 80.226559,
    },
  },
  'LA': {
    sw: {
      lat: 13.909720,
      lng: 100.083214,
    },
    ne: {
      lat: 22.502872,
      lng: 107.694830,
    },
  },
  'LV': {
    sw: {
      lat: 55.674777,
      lng: 20.962343,
    },
    ne: {
      lat: 58.085569,
      lng: 28.241403,
    },
  },
  'LB': {
    sw: {
      lat: 33.055026,
      lng: 35.103778,
    },
    ne: {
      lat: 34.692090,
      lng: 36.623720,
    },
  },
  'LS': {
    sw: {
      lat: -30.675579,
      lng: 27.011231,
    },
    ne: {
      lat: -28.570801,
      lng: 29.455709,
    },
  },
  'LR': {
    sw: {
      lat: 4.315414,
      lng: -11.474248,
    },
    ne: {
      lat: 8.551986,
      lng: -7.369255,
    },
  },
  'LY': {
    sw: {
      lat: 19.500430,
      lng: 9.391466,
    },
    ne: {
      lat: 33.166787,
      lng: 25.146954,
    },
  },
  'LI': {
    sw: {
      lat: 47.048290,
      lng: 9.471620,
    },
    ne: {
      lat: 47.270547,
      lng: 9.635650,
    },
  },
  'LT': {
    sw: {
      lat: 53.896879,
      lng: 20.954368,
    },
    ne: {
      lat: 56.450321,
      lng: 26.835591,
    },
  },
  'LU': {
    sw: {
      lat: 49.447779,
      lng: 5.735670,
    },
    ne: {
      lat: 50.182820,
      lng: 6.530970,
    },
  },
  'MG': {
    sw: {
      lat: -25.606572,
      lng: 43.185139,
    },
    ne: {
      lat: -11.951964,
      lng: 50.483780,
    },
  },
  'MW': {
    sw: {
      lat: -17.135278,
      lng: 32.678889,
    },
    ne: {
      lat: -9.367154,
      lng: 35.924166,
    },
  },
  'MY': {
    sw: {
      lat: 0.853821,
      lng: 99.640573,
    },
    ne: {
      lat: 7.363468,
      lng: 119.269362,
    },
  },
  'MV': {
    sw: {
      lat: -0.703585,
      lng: 72.638581,
    },
    ne: {
      lat: 7.106280,
      lng: 73.759654,
    },
  },
  'ML': {
    sw: {
      lat: 10.147811,
      lng: -12.238885,
    },
    ne: {
      lat: 25.000012,
      lng: 4.266667,
    },
  },
  'MT': {
    sw: {
      lat: 35.805811,
      lng: 14.183548,
    },
    ne: {
      lat: 36.082224,
      lng: 14.575500,
    },
  },
  'MH': {
    sw: {
      lat: 4.572956,
      lng: 160.797959,
    },
    ne: {
      lat: 14.673255,
      lng: 172.170181,
    },
  },
  'MR': {
    sw: {
      lat: 14.721273,
      lng: -17.070134,
    },
    ne: {
      lat: 27.294445,
      lng: -4.833334,
    },
  },
  'MU': {
    sw: {
      lat: -20.525512,
      lng: 56.514367,
    },
    ne: {
      lat: -10.336323,
      lng: 63.503594,
    },
  },
  'MX': {
    sw: {
      lat: 14.534549,
      lng: -118.364430,
    },
    ne: {
      lat: 32.718763,
      lng: -86.710571,
    },
  },
  'FM': {
    sw: {
      lat: 3.822442,
      lng: 138.054982,
    },
    ne: {
      lat: 10.090378,
      lng: 163.035591,
    },
  },
  'MD': {
    sw: {
      lat: 45.466904,
      lng: 26.616856,
    },
    ne: {
      lat: 48.491944,
      lng: 30.162538,
    },
  },
  'MC': {
    sw: {
      lat: 43.724743,
      lng: 7.409105,
    },
    ne: {
      lat: 43.751903,
      lng: 7.439811,
    },
  },
  'MN': {
    sw: {
      lat: 41.581520,
      lng: 87.737620,
    },
    ne: {
      lat: 52.148697,
      lng: 119.931949,
    },
  },
  'ME': {
    sw: {
      lat: 41.849731,
      lng: 18.433792,
    },
    ne: {
      lat: 43.558743,
      lng: 20.357765,
    },
  },
  'MA': {
    sw: {
      lat: 27.666667,
      lng: -13.172891,
    },
    ne: {
      lat: 35.922507,
      lng: -0.996976,
    },
  },
  'MZ': {
    sw: {
      lat: -26.868109,
      lng: 30.215550,
    },
    ne: {
      lat: -10.471202,
      lng: 40.839121,
    },
  },
  'NA': {
    sw: {
      lat: -28.970639,
      lng: 11.724247,
    },
    ne: {
      lat: -16.963486,
      lng: 25.261752,
    },
  },
  'NR': {
    sw: {
      lat: -0.554189,
      lng: 166.909549,
    },
    ne: {
      lat: -0.502640,
      lng: 166.958928,
    },
  },
  'NP': {
    sw: {
      lat: 26.347779,
      lng: 80.052222,
    },
    ne: {
      lat: 30.446945,
      lng: 88.199298,
    },
  },
  'NL': {
    sw: {
      lat: 50.750384,
      lng: 3.357962,
    },
    ne: {
      lat: 53.556021,
      lng: 7.227510,
    },
  },
  'NZ': {
    sw: {
      lat: -52.619418,
      lng: 165.869437,
    },
    ne: {
      lat: -29.231342,
      lng: -175.831536,
    },
  },
  'NI': {
    sw: {
      lat: 10.708055,
      lng: -87.691069,
    },
    ne: {
      lat: 15.030276,
      lng: -82.592071,
    },
  },
  ne: {
    sw: {
      lat: 11.693756,
      lng: 0.166667,
    },
    ne: {
      lat: 23.500000,
      lng: 15.999034,
    },
  },
  'NG': {
    sw: {
      lat: 4.269857,
      lng: 2.676932,
    },
    ne: {
      lat: 13.885645,
      lng: 14.677981,
    },
  },
  'NO': {
    sw: {
      lat: 57.959744,
      lng: 4.500096,
    },
    ne: {
      lat: 71.185476,
      lng: 31.168268,
    },
  },
  'OM': {
    sw: {
      lat: 16.650336,
      lng: 52.000002,
    },
    ne: {
      lat: 26.405395,
      lng: 59.839397,
    },
  },
  'PK': {
    sw: {
      lat: 23.694695,
      lng: 60.872972,
    },
    ne: {
      lat: 37.084107,
      lng: 77.833469,
    },
  },
  'PW': {
    sw: {
      lat: 2.812743,
      lng: 131.120110,
    },
    ne: {
      lat: 8.094023,
      lng: 134.721099,
    },
  },
  'PA': {
    sw: {
      lat: 7.203556,
      lng: -83.052241,
    },
    ne: {
      lat: 9.647779,
      lng: -77.158488,
    },
  },
  'PG': {
    sw: {
      lat: -11.657861,
      lng: 140.841970,
    },
    ne: {
      lat: -0.871319,
      lng: 159.492959,
    },
  },
  'PY': {
    sw: {
      lat: -27.588334,
      lng: -62.638051,
    },
    ne: {
      lat: -19.287707,
      lng: -54.258562,
    },
  },
  'PE': {
    sw: {
      lat: -18.351580,
      lng: -81.328504,
    },
    ne: {
      lat: -0.038777,
      lng: -68.652329,
    },
  },
  'PH': {
    sw: {
      lat: 4.613444,
      lng: 116.931557,
    },
    ne: {
      lat: 19.574024,
      lng: 126.604384,
    },
  },
  'PL': {
    sw: {
      lat: 49.002025,
      lng: 14.122864,
    },
    ne: {
      lat: 54.835812,
      lng: 24.145893,
    },
  },
  'PT': {
    sw: {
      lat: 32.403740,
      lng: -31.275330,
    },
    ne: {
      lat: 42.154205,
      lng: -6.190209,
    },
  },
  'QA': {
    sw: {
      lat: 24.471118,
      lng: 50.750055,
    },
    ne: {
      lat: 26.183093,
      lng: 51.643260,
    },
  },
  'RO': {
    sw: {
      lat: 43.618619,
      lng: 20.261759,
    },
    ne: {
      lat: 48.265274,
      lng: 29.757101,
    },
  },
  'RU': {
    sw: {
      lat: 41.185353,
      lng: 19.640535,
    },
    ne: {
      lat: 81.858122,
      lng: -169.046727,
    },
  },
  'RW': {
    sw: {
      lat: -2.839840,
      lng: 28.861755,
    },
    ne: {
      lat: -1.047572,
      lng: 30.899401,
    },
  },
  'WS': {
    sw: {
      lat: -14.076588,
      lng: -172.803676,
    },
    ne: {
      lat: -13.440033,
      lng: -171.405859,
    },
  },
  'SM': {
    sw: {
      lat: 43.893681,
      lng: 12.403482,
    },
    ne: {
      lat: 43.992075,
      lng: 12.516704,
    },
  },
  'SA': {
    sw: {
      lat: 16.379528,
      lng: 34.548998,
    },
    ne: {
      lat: 32.154284,
      lng: 55.666700,
    },
  },
  'SN': {
    sw: {
      lat: 12.307289,
      lng: -17.529848,
    },
    ne: {
      lat: 16.693054,
      lng: -11.348607,
    },
  },
  'RS': {
    sw: {
      lat: 42.231503,
      lng: 18.838522,
    },
    ne: {
      lat: 46.190032,
      lng: 23.006310,
    },
  },
  'SC': {
    sw: {
      lat: -10.227033,
      lng: 46.197785,
    },
    ne: {
      lat: -4.209786,
      lng: 56.294294,
    },
  },
  'SL': {
    sw: {
      lat: 6.899025,
      lng: -13.302007,
    },
    ne: {
      lat: 9.999972,
      lng: -10.271651,
    },
  },
  'SG': {
    sw: {
      lat: 1.166398,
      lng: 103.605575,
    },
    ne: {
      lat: 1.470772,
      lng: 104.085557,
    },
  },
  'SK': {
    sw: {
      lat: 47.731159,
      lng: 16.833182,
    },
    ne: {
      lat: 49.613805,
      lng: 22.558934,
    },
  },
  'SI': {
    sw: {
      lat: 45.421674,
      lng: 13.375336,
    },
    ne: {
      lat: 46.876659,
      lng: 16.596686,
    },
  },
  'SB': {
    sw: {
      lat: -11.863458,
      lng: 155.486241,
    },
    ne: {
      lat: -6.589240,
      lng: 167.283081,
    },
  },
  'SO': {
    sw: {
      lat: -1.662041,
      lng: 40.994373,
    },
    ne: {
      lat: 11.988614,
      lng: 51.413029,
    },
  },
  'ZA': {
    sw: {
      lat: -34.833138,
      lng: 16.454436,
    },
    ne: {
      lat: -22.125387,
      lng: 32.890991,
    },
  },
  'SS': {
    sw: {
      lat: 3.488980,
      lng: 23.440849,
    },
    ne: {
      lat: 12.236389,
      lng: 35.948997,
    },
  },
  'ES': {
    sw: {
      lat: 27.637789,
      lng: -18.160788,
    },
    ne: {
      lat: 43.792380,
      lng: 4.327784,
    },
  },
  'LK': {
    sw: {
      lat: 5.919078,
      lng: 79.521983,
    },
    ne: {
      lat: 9.836001,
      lng: 81.878703,
    },
  },
  'LC': {
    sw: {
      lat: 13.708118,
      lng: -61.079672,
    },
    ne: {
      lat: 14.110932,
      lng: -60.873098,
    },
  },
  'SD': {
    sw: {
      lat: 9.347221,
      lng: 21.814939,
    },
    ne: {
      lat: 22.224918,
      lng: 38.584219,
    },
  },
  'SR': {
    sw: {
      lat: 1.837306,
      lng: -58.070506,
    },
    ne: {
      lat: 6.009283,
      lng: -53.951024,
    },
  },
  'SZ': {
    sw: {
      lat: -27.317363,
      lng: 30.791094,
    },
    ne: {
      lat: -25.718520,
      lng: 32.134844,
    },
  },
  'SE': {
    sw: {
      lat: 55.328720,
      lng: 10.963187,
    },
    ne: {
      lat: 69.059971,
      lng: 24.166809,
    },
  },
  'CH': {
    sw: {
      lat: 45.817920,
      lng: 5.956080,
    },
    ne: {
      lat: 47.808455,
      lng: 10.492340,
    },
  },
  'SY': {
    sw: {
      lat: 32.311136,
      lng: 35.716596,
    },
    ne: {
      lat: 37.320569,
      lng: 42.376309,
    },
  },
  'TW': {
    sw: {
      lat: 20.563791,
      lng: 116.711860,
    },
    ne: {
      lat: 26.387353,
      lng: 122.006905,
    },
  },
  'TJ': {
    sw: {
      lat: 36.671990,
      lng: 67.342012,
    },
    ne: {
      lat: 41.044367,
      lng: 75.153956,
    },
  },
  'TZ': {
    sw: {
      lat: -11.761254,
      lng: 29.340000,
    },
    ne: {
      lat: -0.984397,
      lng: 40.444965,
    },
  },
  'TH': {
    sw: {
      lat: 5.612729,
      lng: 97.343396,
    },
    ne: {
      lat: 20.465143,
      lng: 105.636812,
    },
  },
  'TG': {
    sw: {
      lat: 6.112358,
      lng: -0.144042,
    },
    ne: {
      lat: 11.139496,
      lng: 1.809050,
    },
  },
  'TO': {
    sw: {
      lat: -21.473461,
      lng: -175.679616,
    },
    ne: {
      lat: -15.566393,
      lng: -173.702484,
    },
  },
  'TN': {
    sw: {
      lat: 30.228034,
      lng: 7.522313,
    },
    ne: {
      lat: 37.358287,
      lng: 11.599217,
    },
  },
  'TR': {
    sw: {
      lat: 35.807680,
      lng: 25.663637,
    },
    ne: {
      lat: 42.106239,
      lng: 44.818128,
    },
  },
  'TM': {
    sw: {
      lat: 35.128760,
      lng: 52.447845,
    },
    ne: {
      lat: 42.798844,
      lng: 66.707353,
    },
  },
  'TV': {
    sw: {
      lat: -10.791659,
      lng: 176.058891,
    },
    ne: {
      lat: -5.642230,
      lng: 179.872261,
    },
  },
  'UG': {
    sw: {
      lat: -1.481542,
      lng: 29.573433,
    },
    ne: {
      lat: 4.223001,
      lng: 35.033049,
    },
  },
  'UA': {
    sw: {
      lat: 44.386463,
      lng: 22.137159,
    },
    ne: {
      lat: 52.379581,
      lng: 40.228581,
    },
  },
  'GB': {
    sw: {
      lat: 49.562515,
      lng: -12.649357,
    },
    ne: {
      lat: 59.860670,
      lng: 3.976555,
    },
  },
  'US': {
    sw: {
      lat: 25.820898,
      lng: -124.712891,
    },
    ne: {
      lat: 49.380240,
      lng: -66.940662,
    },
  },
  'UY': {
    sw: {
      lat: -35.031419,
      lng: -58.439150,
    },
    ne: {
      lat: -30.085215,
      lng: -53.184292,
    },
  },
  'UZ': {
    sw: {
      lat: 37.172257,
      lng: 55.998218,
    },
    ne: {
      lat: 45.590075,
      lng: 73.148946,
    },
  },
  'VU': {
    sw: {
      lat: -20.252293,
      lng: 166.541759,
    },
    ne: {
      lat: -13.072455,
      lng: 170.238460,
    },
  },
  'VA': {
    sw: {
      lat: 41.900198,
      lng: 12.445687,
    },
    ne: {
      lat: 41.907561,
      lng: 12.458480,
    },
  },
  'VE': {
    sw: {
      lat: 0.647529,
      lng: -73.351558,
    },
    ne: {
      lat: 12.486694,
      lng: -59.805666,
    },
  },
  'VN': {
    sw: {
      lat: 8.412730,
      lng: 102.144410,
    },
    ne: {
      lat: 23.393395,
      lng: 109.468975,
    },
  },
  'YE': {
    sw: {
      lat: 12.108166,
      lng: 41.816055,
    },
    ne: {
      lat: 18.999633,
      lng: 54.533555,
    },
  },
  'ZM': {
    sw: {
      lat: -18.077418,
      lng: 21.996388,
    },
    ne: {
      lat: -8.203284,
      lng: 33.702222,
    },
  },
  'ZW': {
    sw: {
      lat: -22.424523,
      lng: 25.237368,
    },
    ne: {
      lat: -15.609319,
      lng: 33.068236,
    },
  },
};
